export function removeAllWhitespace(input: string): string {
  return input.replace(/\s+/g, "");
}
